var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home mainContainer"},[_c('main',{attrs:{"id":"main"}},[_c('div',{staticClass:"mainWelcomeContainer"},[(_vm.isFirstAccess)?_c('first-access'):_c('existing-access')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }